export class Grupo{
    idGrupo: number;
    dsNome: string;


}